import { createFileRoute } from "@tanstack/react-router"
import { DashboardCalendarPage } from "@/pages"

export const Route = createFileRoute(
  "/_authenticated/_organization/dashboard/calendar"
)({
  component: DashboardCalendarPage,
})
